export default __webpack_public_path__ + "static/media/cp_geo_bj.c9649dbb.svg";